import { render, staticRenderFns } from "./price-index.vue?vue&type=template&id=1a05c25f&scoped=true"
import script from "./price-index.vue?vue&type=script&lang=js"
export * from "./price-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05c25f",
  null
  
)

export default component.exports